export const shopItems = [
  // --- BORDERS (Bordures de profil) ---
  {
    id: 'border_bronze',
    name: 'Bordure Bronze',
    description: 'Une bordure antique aux reflets métalliques.',
    category: 'border',
    price: 120,
    currency: 'coins',
    className: 'border-bronze'
  },
  {
    id: 'border_silver',
    name: 'Bordure en Argent',
    description: 'Brillante et élégante.',
    category: 'border',
    price: 155,
    currency: 'coins',
    className: 'border-silver'
  },
  {
    id: 'border_gold',
    name: 'Bordure en Or',
    description: 'Pour les champions.',
    category: 'border',
    price: 195,
    currency: 'coins',
    className: 'border-gold'
  },
  {
    id: 'border_neon',
    name: 'Bordure Néon',
    description: 'Un halo lumineux cyberpunk.',
    category: 'border',
    price: 235,
    currency: 'coins',
    className: 'border-neon'
  },
  {
    id: 'border_fire',
    name: 'Bordure de Feu',
    description: 'Une bordure épique et brûlante.',
    category: 'border',
    price: 20,
    currency: 'diamonds',
    className: 'border-fire-animated' // We will define this in CSS later
  },
  {
    id: 'border_celestial',
    name: 'Bordure Céleste',
    description: 'Une bordure divine animée.',
    category: 'border',
    price: 40,
    currency: 'diamonds',
    className: 'border-celestial-animated'
  },


  {
    id: 'border_plasma',
    name: 'Bordure Plasma',
    description: 'Une énergie instable verte et violette.',
    category: 'border',
    price: 345,
    currency: 'coins',
    className: 'border-plasma-animated'
  },
  {
    id: 'border_aurora',
    name: 'Bordure Aurore',
    description: 'De magnifiques ondes lumineuses boréales.',
    category: 'border',
    price: 380,
    currency: 'coins',
    className: 'border-aurora-animated'
  },
  // --- THEMES (Couleurs de l'app) ---
  {
    id: 'theme_neon',
    name: 'Thème Cyberpunk',
    description: 'Néon violet, bleu et rose pour un look futuriste.',
    category: 'theme',
    price: 375,
    currency: 'coins',
    themeMode: 'dark',
    variables: {
      '--primary-color': '#ff00ff',
      '--secondary-color': '#1e90ff',
      '--bg-color': '#0a0a1a',
      '--bg-card': '#1a1a2e',
      '--text-primary': '#ffffff',
      '--text-secondary': '#a0a0b0'
    }
  },
  {
    id: 'theme_nature',
    name: 'Thème Zen / Nature',
    description: 'Vert forêt et tons apaisants pour la relaxation.',
    category: 'theme',
    price: 280,
    currency: 'coins',
    themeMode: 'light',
    variables: {
      '--primary-color': '#2e7d32',
      '--secondary-color': '#81c784',
      '--bg-color': '#f1f8e9',
      '--bg-card': '#ffffff',
      '--text-primary': '#1b5e20',
      '--text-secondary': '#388e3c'
    }
  },
  {
    id: 'theme_abyssal',
    name: 'Thème Abyssal',
    description: 'Sombre et mystérieux, pour une concentration maximale.',
    category: 'theme',
    price: 35,
    currency: 'diamonds',
    themeMode: 'dark',
    variables: {
        '--primary-color': '#87b9de',
        '--secondary-color': '#0077b6',
        '--bg-color': '#0b132b',
        '--bg-card': '#1c2541',
        '--text-primary': '#ffffff',
        '--text-secondary': '#a1b4c4'
      }
  },
  {
    id: 'theme_sunrise',
    name: 'Thème Aube',
    description: 'Couleurs chaudes et matinales pour bien commencer la journée.',
    category: 'theme',
    price: 325,
    currency: 'coins',
    themeMode: 'light',
    variables: {
      '--primary-color': '#ff7e5f',
      '--secondary-color': '#feb47b',
      '--bg-color': '#fff3e0',
      '--bg-card': '#ffffff',
      '--text-primary': '#d35400',
      '--text-secondary': '#e67e22'
    }
  },
  {
    id: 'theme_nebula',
    name: 'Thème Nébuleuse',
    description: 'Un voyage spatial aux teintes violettes et sombres.',
    category: 'theme',
    price: 435,
    currency: 'coins',
    themeMode: 'dark',
    variables: {
      '--primary-color': '#f8a5c2',
      '--secondary-color': '#b39ddb',
      '--bg-color': '#130f26',
      '--bg-card': '#1f1b38',
      '--text-primary': '#fbd9b9',
      '--text-secondary': '#d1c4e9'
    }
  },


    {
      id: 'theme_cotton',
      name: 'Thème Coton',
      description: 'Des tons bleus et roses pastel très doux pour une interface aérienne et épurée.',
      category: 'theme',
      price: 300,
      currency: 'coins',
      themeMode: 'light',
      variables: {
        '--primary-color': '#64b5f6',
        '--secondary-color': '#ff9ff3',
        '--bg-color': '#f5f6fa',
        '--bg-card': '#ffffff',
        '--text-primary': '#2f3640',
        '--text-secondary': '#718093'
      }
    },
  // --- TITLES (Titres sous le pseudo) ---
  {
    id: 'title_beginner',
    name: 'Titre : "Nouvelle Recrue"',
    description: 'Tout le monde commence quelque part.',
    category: 'title',
    price: 70,
    currency: 'coins',
    value: '🌱 Nouvelle Recrue'
  },
  {
    id: 'title_iron',
    name: 'Titre : "Mangeur de Fonte"',
    description: 'Pour ceux qui aiment soulever lourd.',
    category: 'title',
    price: 105,
    currency: 'coins',
    value: 'Mangeur de Fonte'
  },
  {
    id: 'title_veteran',
    name: 'Titre : "Vétéran"',
    description: 'L\'expérience parle d\'elle-même.',
    category: 'title',
    price: 145,
    currency: 'coins',
    value: 'Vétéran'
  },
  {
    id: 'title_legend',
    name: 'Titre : "Légende Vivante"',
    description: 'Le statut ultime.',
    category: 'title',
    price: 15,
    currency: 'diamonds',
    value: '👑 Légende Vivante 👑'
  },
  {
    id: 'title_machine',
    name: 'Titre : "Machine de Guerre"',
    description: "Rien ne peut t'arrêter.",
    category: 'title',
    price: 195,
    currency: 'coins',
    value: '🤖 Machine de Guerre'
  },
  {
    id: 'title_earlybird',
    name: 'Titre : "Lève-tôt"',
    description: 'L\'avenir appartient à ceux qui s\'entraînent tôt.',
    category: 'title',
    price: 85,
    currency: 'coins',
    value: '🌅 Lève-tôt'
  },
  {
    id: 'title_flan',
    name: 'Titre : "Tablette de Flan"',
    description: 'Pour ceux qui n\'ont pas encore les abdos apparents.',
    category: 'title',
    price: 125,
    currency: 'coins',
    value: '🍮 Tablette de Flan'
  },
  {
    id: 'title_beer',
    name: 'Titre : "Soulevé de Bière"',
    description: 'Idéal pour l\'entraînement du vendredi soir.',
    category: 'title',
    price: 175,
    currency: 'coins',
    value: '🍺 Soulevé de Bière'
  },
  {
    id: 'title_prototype',
    name: 'Titre : "Prot-otype"',
    description: 'L\'athlète en pleine construction.',
    category: 'title',
    price: 225,
    currency: 'coins',
    value: '⚙️ Prot-otype'
  },


    {
      id: 'title_cheatmeal',
      name: 'Titre : "Pro du Cheat Meal"',
      description: 'Spécialiste de la junk food.',
      category: 'title',
      price: 150,
      currency: 'coins',
      value: '🍔 Pro du Cheat Meal'
    },
    {
      id: 'title_sofa',
      name: 'Titre : "Athlète du Canapé"',
      description: 'Le repos, c\'est important.',
      category: 'title',
      price: 90,
      currency: 'coins',
      value: '🛋️ Athlète du Canapé'
    },
    {
      id: 'title_nopain',
      name: 'Titre : "No Pain No Tartine"',
      description: 'La vraie motivation du matin.',
      category: 'title',
      price: 130,
      currency: 'coins',
      value: '🥖 No Pain No Tartine'
    },
  // --- MASCOTS (Compagnons virtuels) ---
  {
    id: 'mascot_cat',
    name: 'Chat Calico',
    description: 'Un chat joueur avec de magnifiques taches.',
    category: 'mascot',
    price: 45,
    currency: 'diamonds'
  },
  {
    id: 'mascot_kettlebell',
    name: 'Kettle-Pet',
    description: 'Une petite kettlebell vivante très mignonne.',
    category: 'mascot',
    price: 635,
    currency: 'coins'
  },
  {
    id: 'mascot_blob',
    name: 'Blob Gélatineux',
    description: 'Une petite masse d\'énergie pure et mignonne.',
    category: 'mascot',
    price: 570,
    currency: 'coins'
  },
  {
    id: 'mascot_shiba',
    name: 'Renard',
    description: 'Un petit renard très malin et adorable.',
    category: 'mascot',
    price: 65,
    currency: 'diamonds'
  },
  {
    id: 'mascot_fitbot',
    name: 'Fit-Bot',
    description: 'Un robot d\'entraînement de haute technologie.',
    category: 'mascot',
    price: 695,
    currency: 'coins'
  },

  // --- ACCESSORIES (Accessoires de compagnons) ---
  {
    id: 'accessory_glasses',
    name: 'Lunettes de Soleil',
    description: 'Trop cool pour ce monde.',
    category: 'mascot_accessory',
    price: 250,
    currency: 'coins'
  },
  {
    id: 'accessory_headband',
    name: 'Bandeau Ninja',
    description: 'Bandeau rouge de la détermination.',
    category: 'mascot_accessory',
    price: 325,
    currency: 'coins'
  },
  {
    id: 'accessory_necklace',
    name: 'Collier Orné',
    description: 'Un magnifique collier en or avec un rubis.',
    category: 'mascot_accessory',
    price: 285,
    currency: 'coins'
  },
  {
    id: 'accessory_crown',
    name: 'Couronne Dorée',
    description: 'Pour le compagnon du roi.',
    category: 'mascot_accessory',
    price: 30,
    currency: 'diamonds'
  },

  // --- CHESTS (Lootboxes) ---
  {
    id: 'chest_basic',
    name: 'Coffre Classique',
    description: 'Contient un peu d\'XP et une petite chance d\'obtenir des diamants !',
    category: 'chest',
    price: 100,
    currency: 'coins'
  },
  {
    id: 'chest_epic',
    name: 'Coffre Épique',
    description: 'Contient beaucoup d\'XP et une bonne chance d\'obtenir des diamants !',
    category: 'chest',
    price: 200,
    currency: 'coins'
  },
  {
    id: 'chest_legendary',
    name: 'Coffre Légendaire',
    description: 'Contient énormément d\'XP et des diamants garantis !',
    category: 'chest',
    price: 310,
    currency: 'coins'
  }
];
